import Link from 'next/link';

import { resolveStoryblokLinkHref } from '@utils/resolveStoryblokLinkHref';
import type { FilmCategoryCardStoryblok } from '@utils/storyblok/storyblok';
import { Button } from '@common/interaction/Button';
import { Image } from '@common/layout/Image';

export function FilmCategoryCard({ title, description, image, link }: FilmCategoryCardStoryblok) {
  const href = resolveStoryblokLinkHref(link);

  return (
    <article className="group flex h-full flex-col overflow-hidden border border-primary/10 bg-[#f7f4ef] transition-transform duration-300 hover:-translate-y-1 focus-within:-translate-y-1">
      {image?.filename && (
        <div className="relative aspect-[4/5] overflow-hidden">
          <Image
            asset={{
              ...image,
              alt: image.alt || title || 'Film category',
            }}
            className="object-cover transition-transform duration-500 group-hover:scale-105 group-focus-within:scale-105"
            imageSizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          />
        </div>
      )}

      <div className="flex flex-1 flex-col space-y-3 p-6 md:p-8">
        {title && <h3 className="font-heading text-2xl text-primary md:text-3xl">{title}</h3>}

        {description && (
          <p className="text-sm leading-7 text-primary md:text-base">{description}</p>
        )}

        {link && (
          <div className="mt-auto pt-4">
            <Button
              asChild
              className="w-full font-normal no-underline hover:no-underline"
              aria-label={title ? `Bekijk categorie: ${title}` : 'Bekijk categorie'}
              color="primary"
            >
              <Link href={href}>Bekijk categorie</Link>
            </Button>
          </div>
        )}
      </div>
    </article>
  );
}
